(function imageDefinition() {
    'use strict';
    angular.module('Entities')
        .service('imageService', [
            'restUrlBuilder', '$injector', 'config',
            function imageService(restUrlBuilder, $injector, config) {

                this.getById = function getById(id) {
                    return restUrlBuilder.one('images', id).get();
                };

                this.getImages = function get(id) {
                    var params = { DocumentId: id };

                    return restUrlBuilder.all('images')
                        .get({ params: params });
                };

                this.download = function download(id) {
                    return restUrlBuilder.one('images/Download', id).get();
                };

                this.generatePDF = function generatePDF(docId) {
                    return restUrlBuilder.one('images/Documents', docId)
                     .all('GeneratePDF')
                     .put();
                }
            }
        ]);
})();